import React, { useState, useEffect } from "react";
import axios from "axios";
import cheerio from "cheerio";


const extractStylesAndScripts = (htmlContent) => {
  const $ = cheerio.load(htmlContent);
  const styles = $('style').map((i, el) => $(el).html()).get().join('\n');
  const scripts = $('script').map((i, el) => $(el).html()).get().join('\n');
  return { styles, scripts };
};

const addStylesAndScripts = ({ styles, scripts }) => {
  const head = document.getElementsByTagName('head')[0];
  const styleElement = document.createElement('style');
  styleElement.innerHTML = styles;
  head.appendChild(styleElement);
  const scriptElement = document.createElement('script');
  scriptElement.innerHTML = scripts;
  head.appendChild(scriptElement);
};

const fetchPage = async (url) => {
  const response = await axios.get(url);
  return response.data;
}; 






// export const fetchReviews = async () => {
//   try {
//     const htmlContent = await fetchPage(
//       "https://api.codetabs.com/v1/proxy?quest=https://www.freelancer.com/u/meharites"
//     );
//     const { styles, scripts } = extractStylesAndScripts(htmlContent);
//     const modifiedHtml = addStylesAndScripts(htmlContent, styles, scripts);
//     const purifiedHtmlContent = modifiedHtml.replace(/&/g, "&amp;");
//     const $ = cheerio.load(purifiedHtmlContent);
//     const reviewsSections = $("fl-list");
//     if (reviewsSections.length > 0) {
//       console.log("Reviews section",reviewsSections)
//       const reviewsArray = [];
//       reviewsSections.each((index, element) => {
//         const reviewsListItems = $(element).find("fl-list-item");
//         if (reviewsListItems.length > 0) {
//           const reviewsList = reviewsListItems.map((i, el) => {
//             const review = $(el).find(".review-text").text().trim();
//             const rating = $(el).find(".review-rating").text().trim();
//             const reviewer = $(el).find(".reviewer-name").text().trim();
//             return ( <div key={i}> <h3>{reviewer}</h3><p>{review}</p><p>Rating: {rating}</p></div> ); }); reviewsArray.push(<div key={index}><h2>Reviews:</h2>
//               {reviewsList}</div> ); }}); return reviewsArray;} else {
//       throw new Error("Could not find reviews section");}} catch (error) { throw new Error(error.message);}};




// export const fetchReviews = async () => {
//   try {
//     const htmlContent = await fetchPage(
//       "https://api.codetabs.com/v1/proxy?quest=https://www.freelancer.com/u/meharites"
//     );
//     const { styles, scripts } = extractStylesAndScripts(htmlContent);
//     const modifiedHtml = addStylesAndScripts(htmlContent, styles, scripts);
//     const purifiedHtmlContent = modifiedHtml.replace(/&/g, "&amp;");
//     const $ = cheerio.load(purifiedHtmlContent);
//     const reviewsListItems = $("fl-list > fl-list-item");
//     if (reviewsListItems.length > 0) {
//       const reviewsArray = [];
//       reviewsListItems.each((index, element) => {
//         const review = $(element).find(".review-text").text().trim();
//         const rating = $(element).find(".review-rating").text().trim();
//         const reviewer = $(element).find(".reviewer-name").text().trim();
//         const reviewObject = { review, rating, reviewer };
//         reviewsArray.push(reviewObject);
//       });
//       return reviewsArray;
//     } else {
//       throw new Error("Could not find reviews section");
//     }
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };



// export const fetchReviews = async () => {
//   try {
//     const htmlContent = await fetchPage(
//       "https://api.codetabs.com/v1/proxy?quest=https://www.freelancer.com/u/meharites"
//     );
//     const { styles, scripts } = extractStylesAndScripts(htmlContent);
//     addStylesAndScripts({ styles, scripts });
//     const purifiedHtmlContent = htmlContent.replace(/&/g, "&amp;");
//     const $ = cheerio.load(purifiedHtmlContent);
//     const reviewsListItems = $("fl-list > fl-list-item");
//     if (reviewsListItems.length > 0) {
//       const reviewsArray = [];
//       reviewsListItems.each((index, element) => {
//         const modifiedHtml = addStylesAndScripts($(element).html(), styles, scripts);
//         const $element = cheerio.load(modifiedHtml);
//         const review = $element.find(".review-text").text().trim();
//         const rating = $element.find(".review-rating").text().trim();
//         const reviewer = $element.find(".reviewer-name").text().trim();
//         reviewsArray.push(
//           `<div key=${index}>
//             <h3>${reviewer}</h3>
//             <p>${review}</p>
//             <p>Rating: ${rating}</p>
//           </div>`
//         );
//       });
//       return reviewsArray;
//     } else {
//       throw new Error("Could not find reviews section");
//     }
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };


// export const fetchReviews = async () => {
//   try {
//     const htmlContent = await fetchPage(
//       "https://api.codetabs.com/v1/proxy?quest=https://www.freelancer.com/u/meharites"
//     );
//     const { styles, scripts } = extractStylesAndScripts(htmlContent);
//     addStylesAndScripts({ styles, scripts });
//     const purifiedHtmlContent = htmlContent.replace(/&/g, "&amp;");
//     const $ = cheerio.load(purifiedHtmlContent);
//     const reviewsListItems = $("fl-list > fl-list-item");
//     if (reviewsListItems.length > 0) {
//       const reviewsArray = [];
//       reviewsListItems.each((index, element) => {
//         const modifiedHtml = addStylesAndScripts($(element).html(), styles, scripts);
//         const $element = cheerio.load(modifiedHtml);
//         const review = $element.find(".BitsListItemContainer").text().trim();
//         const rating = $element.find(".review-rating").text().trim();
//         const reviewer = $element.find(".reviewer-name").text().trim();
//         const parentStyles = $(element).closest("fl-list").attr("style");
//         reviewsArray.push(
//           `<div key=${index} style="${parentStyles}">
//             <h3>${reviewer}</h3>
//             <p>${review}</p>
//             <p>Rating: ${rating}</p>
//           </div>`
//         );
//       });
//       return reviewsArray;
//     } else {
//       throw new Error("Could not find reviews section");
//     }
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };























// export const fetchReviews = async () => {
//   try {
//     const htmlContent = await fetchPage(
//       "https://api.codetabs.com/v1/proxy?quest=https://www.freelancer.com/u/meharites"
//     );
//     const { styles, scripts } = extractStylesAndScripts(htmlContent);
//     addStylesAndScripts({ styles, scripts });
//     const purifiedHtmlContent = htmlContent.replace(/&/g, "&amp;");
//     const $ = cheerio.load(purifiedHtmlContent);
//     const reviewsListItems = $("fl-list > _ngcontent-webapp-c305");
//     if (reviewsListItems.length > 0) {
//       const reviewsArray = [];
//       reviewsListItems.each((index, element) => {
//         const review = $(element).text().trim();
//         reviewsArray.push(review);
//       });
//       return reviewsArray;
//     } else {
//       throw new Error("Could not find reviews section");
//     }
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };





export const fetchReviews = async () => {
  try {
    const htmlContent = await fetchPage(
      "https://api.codetabs.com/v1/proxy?quest=https://www.freelancer.com/u/meharites"
    );
    const { styles, scripts } = extractStylesAndScripts(htmlContent);
    addStylesAndScripts({ styles, scripts });
    const purifiedHtmlContent = htmlContent.replace(/&/g, "&amp;");
    const $ = cheerio.load(purifiedHtmlContent);
    const reviewsSections = $("fl-list > fl-list-item");
    if (reviewsSections.length > 0) {
      const reviewsArray = [];
      reviewsSections.each((index, element) => {
        const review = $(element).html().replace(/&/g, "&amp;");
        reviewsArray.push( <div>
          <h2>Reviews:</h2>
          <div dangerouslySetInnerHTML={{ __html: review }} />
        </div>);
      });
      return reviewsArray;
    } else {
      throw new Error("Could not find reviews section");
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

// export const Logo = async () => {
//   try {
//     const htmlContent = await fetchPage('https://www.freelancer.in/dashboard');
//     const { styles, scripts } = extractStylesAndScripts(htmlContent);
//     addStylesAndScripts({ styles, scripts });
//     const purifiedHtmlContent = htmlContent.replace(/&/g, '&amp;');
//     const $ = cheerio.load(purifiedHtmlContent);
//     const logoHtml = $('body > app-root > app-logged-in-shell > div > div.PageHeader.ng-tns-c685-5 > div > app-navigation > fl-bit > app-navigation-child > fl-view-header > fl-bit > fl-bit > fl-bit > fl-bit > fl-bit.NavigationChild-title > fl-heading > h1 > fl-logo > picture');
//     console.log("logoo",logoHtml)
//     return <div dangerouslySetInnerHTML={{ __html: logoHtml.first().html() }} />;
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };




// async function main() {
//   try {
//     const reviews = await fetchReviews();
//     const data = reviews.map((review) => ({ review }));
//     console.log("rrrrrrrrrr222222222",data,reviews);
//   } catch (error) {
//     console.error(error.message);
//   }
// }

// main()
// console.log("rrrrrrrrrrrrrrreview",fetchReviews)
// fetchReviews().then((reviews) => {
//   console.log("kkkk",reviews);
// }).catch((error) => {
//   console.error(error);
// });
// const Review = () => {
//   const [reviews, setReviews] = useState([]);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const getReviews = async () => {
//       try {
//         const reviewsArray = await fetchReviews();
//         setReviews(reviewsArray);
//       } catch (error) {
//         setError(error.message);
//       }
//     };
//     getReviews();
//   }, []);
// };





const FreelancerProfile = () => {
  const [reviews, setReviews] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const htmlContent = await fetchReviews();
        setReviews(htmlContent);
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <h2>Reviews:</h2>
      <div dangerouslySetInnerHTML={{ __html: reviews }} />
    </div>
  );
};

export default FreelancerProfile;